import React, { useContext, useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import AssuranceContext from "../../context/index";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Hidden, Typography } from "@material-ui/core";
import { logout } from "../../helpers/utils";
import { buildSystemErrorMessage } from "../../helpers/proposal";
import { getWebService } from "../../helpers/server";
import { ReducerUtils } from "../../constants/reducers";
import { useStyles } from "./dashboardStyles";
import { AUTHORIZATION } from "../../constants/index";
import ProfileSection from "./profileSection";

function Profile({
  classes: { backSolid, contentBox, loaderBox, main, mainContainer },
}) {
  const { state, dispatch } = useContext(AssuranceContext);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => fetchProfile(), []);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const cbError = ({ data: { error, error_msg } }) => {
    setIsLoaded(true);
    if (error === AUTHORIZATION) {
      logout();
      window.location.href = "/";
    } else {
      console.log(`error_msg = ${error_msg}`);
    }
  };

  const cbFetchProfile = ({ data }) => {
    console.log(data);
    dispatchEvent(ReducerUtils.profile.details, data);
    setIsLoaded(true);
  };

  const fetchProfile = async () => {
    try {
      const response = await getWebService("service_centres/detail");
      cbFetchProfile(response.data);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  return (
    <>
      {isLoaded ? (
        <Box className={main}>
          <Box className={mainContainer}>
            <Box className={contentBox}>
              <>
                {/* <Box className={backSolid}>
                  <Box>
                    <Typography variant={"h6"}>Profile Section</Typography>
                  </Box>
                </Box> */}

                <ProfileSection />
                
                <Hidden smDown>
                  <Box m={5}>&nbsp;</Box>
                </Hidden>
              </>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box className={loaderBox}>
          <CircularProgress color={"secondary"} />
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(Profile);
